import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { loadingState } from 'src/atom/LoadingState'
import { useRecoilState } from 'recoil'
import { globalStream } from 'src/atom/GlobalStream'
import { useNavigate } from 'react-router-dom'
import Tostify, { showToast } from 'src/utils/Tostify'
import { validateCandidate } from 'src/services/Registration/RegisterationService'
import {
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import LogoHeader from 'src/components/header/LogoHeader'
import { getCutOffDetails } from 'src/services/PreRegistration/PreRegistration'

const OnboardingRegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState()
  const [loader, enableLoader] = useRecoilState(loadingState)
  const [loading, setLoading] = useState(false)
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const [cutOff, setCutOff] = useState([])
  const counsellingNameFromGlobalStream = useRecoilValue(globalStream).counsellingName
  const [counsellingName, setCounsellingName] = useState(counsellingNameFromGlobalStream)
  const [scoreCard, setScoreCard] = useState('')

  useEffect(() => {

    if (counsellingName === 'PG') {
      setScoreCard('AIAPGET 2026')
    } else if (counsellingName === 'UG') {
      setScoreCard('NEET-UG 2026')
    }
  }, [counsellingName])

  const navigate = useNavigate()

  useEffect(() => {
    fetchCutOffDetails()
    if (!counsellingName) {
      navigate('/homepage')
    }
  }, [counsellingName])


  const candidateObj = {
    neetRollNumber: '',
    name: '',
    counsellingName: '',
    dob: '',
  }
  const [formData, setFormData] = useState(candidateObj)
  const [validationErrors, setValidationErrors] = useState({
    neetRollNumber: '',
    name: '',
    counsellingName: '',
    dob: '',
  })

  const validateForm = () => {
    let errors = {}
    let isValid = true
    if (
      !formData.neetRollNumber ||
      formData.neetRollNumber === null ||
      formData.neetRollNumber === ''
    ) {
      errors.neetRollNumber = 'Please provide roll number'
      isValid = false
    }
    if (!formData.name || formData.name === null || formData.name === '') {
      errors.name = 'Please provide candidate name'
      isValid = false
    }
    if (counsellingName === 'UG' && !formData.dob) {
      errors.dob = 'Please provide date of birth'
      isValid = false
    }
    setValidationErrors(errors)
    return isValid
  }

  const fetchCutOffDetails = async () => {
    enableLoader(true)
    const fetchAllCutOff = async () => {
      setData(true)
      var response = await getCutOffDetails(counsellingName)
      if (response?.success) {
        setData(false)
        setCutOff(response?.body)
        enableLoader(false)
      } else {
        setData(false)
        enableLoader(false)
      }
    }
    fetchAllCutOff()
  }


  const handleSubmit = async (e) => {
    e.preventDefault()
    const isValid = validateForm()
    setIsSubmitting(true)
    if (isValid) {
      const updatedFormData = { ...formData, counsellingName: counsellingName }
      enableLoader(true)
      const response = await validateCandidate(updatedFormData)
      if (response.success) {
        const newGlobalSteam = {
          neetRollNumber: response.body?.neetRollNumber,
          email: response.body?.email,
          phoneNumber: response.body?.phoneNumber,
          counsellingId: response.body?.counsellingId,
          counsellingName: counsellingName,
        }
        setGlobalSteam(newGlobalSteam)
        setLoading(true)
        enableLoader(false)
        setIsSubmitting(false)
        navigate('/registration-details', { state: { ...newGlobalSteam } })
        setVisible(false)
      } else {
        setIsSubmitting(false)
        showToast(response.message, 'error')
        enableLoader(false)
      }
    }
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  return (
    <>
      <div className="container-fluid" style={{ padding: '10px 20px' }}>
        <LogoHeader />
        <div
          className="mt-2 d-flex justify-content-center align-items-center"
          style={{ fontWeight: 'bold', fontSize: '25px' }}
        >
          Online Application Form For Admission To{' '}
          {GSteam.counsellingName === 'UG' ? 'BAMS/BHMS ' : 'MD/MS (Ayurveda) '} courses 2026-27
        </div>
        <div className="card ms-5 me-5 mt-3">
          <div className="card-body">
            <div className="row">
              <div className="col-12 d-flex justify-content-start">
                <th>
                  {GSteam?.counsellingName === 'UG' ? 'NEET UG 2026' : 'AIAPGET 2026'} Details
                </th>
              </div>
            </div>
            <hr />
            <div className="container">
              <div className="container mt-4">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-5 mb-3">
                            <label htmlFor="name">Name Of Candidate<span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className={`form-control ${validationErrors?.name ? 'is-invalid' : ''
                                }`}
                              id="name"
                              placeholder="Enter Candidate Name"
                              name="name"
                              value={formData?.name}
                              onChange={handleInputChange}
                              pattern="^[a-zA-Z ]+$"
                              title="Name should only contain letters and spaces"
                              onKeyDown={(e) => /[^a-zA-Z ]/.test(e.key) && e.preventDefault()}
                            />
                            {validationErrors?.name && (
                              <div className="invalid-feedback">{validationErrors?.name}</div>
                            )}
                          </div>
                          <div className="col-md-5 mb-3">
                            <div className="form-group">
                              <label htmlFor="neetRollNumber">
                                {GSteam?.counsellingName === 'UG' ? 'NEET UG 2026' : 'AIAPGET 2026'}{' '}
                                Roll Number<span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${validationErrors?.neetRollNumber ? 'is-invalid' : ''
                                  }`}
                                id="neetRollNumber"
                                placeholder="Enter Roll Number..."
                                name="neetRollNumber"
                                value={formData?.neetRollNumber}
                                onChange={handleInputChange}
                                pattern="^[a-zA-Z0-9]+$"
                                onKeyDown={(e) =>
                                  /^[a-zA-Z0-9]$/.test(e.key) || e.key === 'Backspace' || e.key === ' ' || e.preventDefault()
                                }
                              />
                              {validationErrors.neetRollNumber && (
                                <div className="invalid-feedback">
                                  {validationErrors?.neetRollNumber}
                                </div>
                              )}
                            </div>
                          </div>
                          {counsellingName === 'UG' && (
                            <div className="col-md-5 mb-3">
                              <div className="form-group">
                                <label htmlFor="dob">Date of Birth<span className="text-danger">*</span></label>
                                <input
                                  type="date"
                                  className={`form-control ${validationErrors?.dob ? 'is-invalid' : ''
                                    }`}
                                  id="dob"
                                  name="dob"
                                  value={formData?.dob}
                                  onChange={handleInputChange}
                                  max="2009-12-31"
                                  title="Date should be in the format YYYY-MM-DD"
                                />
                                {validationErrors?.dob && (
                                  <div className="invalid-feedback">{validationErrors?.dob}</div>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-md-2 mb-3">
                            <button
                              type="submit"
                              className="btn btn-primary text-white  btn-block mt-4"
                              onClick={handleSubmit}
                              disabled={
                                isSubmitting ||
                                !formData.neetRollNumber ||
                                !formData.name ||
                                (counsellingName === 'UG' && !formData.dob)
                              }
                            >
                              {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 ms-3 row mt-2">
              <div className="col-sm-12">
                <th>Important Instruction:-</th>
                <ul>
                  <li>
                    Candidate are required to fill details as per{' '}
                    {GSteam?.counsellingName === 'UG' ? 'NEET-UG ' : 'AIAPGET '} 2026 Score Card.
                  </li>
                  <li>
                    No rectification in the basic data filled during{' '}
                    {GSteam?.counsellingName === 'UG' ? 'NEET-UG ' : 'AIAPGET '} 2026 registration will
                    be allowed by the system.
                  </li>
                </ul>
                <hr />

                <th>
                  Minimum {scoreCard} Eligibility Criteria for Admission to{' '}
                  {GSteam?.counsellingName === 'UG' ? 'NEET-UG ' : 'AIAPGET '} course:
                </th>

                <div className="ms-3 form-check">
                  <label className="ms-2 form-check-label">
                    The Minimum eligibility criteria for admission to
                    {GSteam?.counsellingName === 'UG'
                      ? ' BAMS/BHMS courses is as per Information Bulletin NEET (UG)- 2026 '
                      : ' MD/MS (Ayurveda) course is issued by AACCC, Ministry of Ayush, Govt. of India time to time '}
                    . The Last eligibility criteria is mentioned as below -
                  </label>
                </div>

                <div className="card">
                  <div className="card-body">
                    {data == true ? (
                      enableLoader(true)
                    ) : (
                      <CCol xs={12}>
                        <CTable striped responsive>
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell scope="col">Category</CTableHeaderCell>
                              <CTableHeaderCell scope="col">
                                {GSteam?.counsellingName === 'UG' ? 'NEET-UG ' : 'AIAPGET '}
                                2026 CUT-off percentile/Score as per Qualifying Criteria
                              </CTableHeaderCell>
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {cutOff.length > 0 ? (
                              cutOff.map((data, index) => {
                                return (
                                  <CTableRow key={index} style={{ height: '10px' }}>
                                    <CTableDataCell>{data?.categoryName}</CTableDataCell>
                                    <CTableDataCell>{data?.cutOffScore}</CTableDataCell>
                                  </CTableRow>
                                )
                              })
                            ) : (
                              <CTableRow>
                                <CTableDataCell colSpan={6}>No Cut Off Detail found</CTableDataCell>
                              </CTableRow>
                            )}
                          </CTableBody>
                        </CTable>
                      </CCol>
                    )}
                  </div>
                </div>
                <div className="form-check">
                  <label className="mt-4 form-check-label" style={{ color: 'red' }}>
                    {GSteam?.counsellingName === 'UG'
                      ? `Note :- If you want to participate in the BAMS/BHMS admissions counselling process, then
                    you have to produce valid category & NEET-UG Score certificate at the time of
                    document verification. The same should also be uploaded during the registration
                    process.`
                      : `Note :- One year compulsory Rotatory Internship shall be an essential pre-qualification
                    for eligibility for admission to MD/MS (Ayurveda) for the
                    academic session 2026-27. The Cut off date for completion of internship shall be
                    as per notification and corrigendum.`}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Tostify />
    </>
  )
}

export default OnboardingRegistration
